import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";

export default function RefundPolicyPage() {
  return (
    <div className="min-h-screen bg-background">
      <header className="border-b border-slate-200 bg-white">
        <div className="max-w-5xl mx-auto px-4 py-4 flex items-center gap-3">
          <Link to="/" className="flex items-center gap-3" data-testid="refund-policy-brand-link">
            <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-white shadow-sm ring-1 ring-slate-200">
              <img src="/logo.png" alt="DocMania logo" className="h-8 w-8 object-contain" />
            </div>
            <span className="text-xl font-extrabold tracking-tight text-slate-900">
              <span className="text-blue-600">Doc</span>
              <span className="text-orange-500">Mania</span>
            </span>
          </Link>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-4 py-12">
        <Link to="/" className="inline-flex items-center gap-1.5 text-sm text-muted-foreground hover:text-foreground mb-8">
          <ArrowLeft className="h-4 w-4" /> Back to Home
        </Link>
        <h1 className="text-3xl font-bold text-foreground mb-4" data-testid="refund-policy-title">Refund Policy</h1>

        <div className="prose prose-sm text-foreground/90 space-y-6">
          <p>This policy explains how refunds are handled for credit purchases made on DocMania.</p>

          <section>
            <h2 className="text-lg font-semibold">Non-refundable credits</h2>
            <p>All credit purchases are final and non-refundable, including unused credits. Because credits can be used flexibly at any time and never expire, we do not offer refunds for change-of-mind or unused balances.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold">Exception — platform errors</h2>
            <p>If a credit is deducted due to a technical error on our end and no usable document was produced, contact <a href="mailto:support@docmania.co" className="text-primary hover:underline">support@docmania.co</a> with your account email and order reference. We will reinstate the credit or issue a refund once the issue is confirmed.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold">How to reach us</h2>
            <p>Email <a href="mailto:support@docmania.co" className="text-primary hover:underline">support@docmania.co</a> with your account email and transaction ID. We aim to respond within 2 business days.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold">Payment processing</h2>
            <p>Payments are processed by Flutterwave. Flutterwave&apos;s own buyer protection and dispute policies may apply in addition to this policy.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold">Related policies</h2>
            <p>See also our <Link to="/terms" className="text-primary hover:underline">Terms of Service</Link> and <Link to="/privacy" className="text-primary hover:underline">Privacy Policy</Link> for more on how DocMania operates.</p>
          </section>
        </div>
      </main>
    </div>
  );
}
